import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ea76797"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-image" }, null, -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "viewAll-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-image" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View All", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_skeleton_media = _resolveComponent("app-skeleton-media")!
  const _component_item_photo = _resolveComponent("item-photo")!
  const _component_item_video = _resolveComponent("item-video")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!

  return (_ctx.photos.length || _ctx.dataLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_item_wrapper, null, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isNetwork ? _ctx.$localize('drive.network.photos.title') : _ctx.$localize('drive.section.photo.title')), 1)
          ]),
          control: _withCtx(() => [
            _createElementVNode("span", {
              class: "black-link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewAllPhotos && _ctx.viewAllPhotos(...args)))
            }, _toDisplayString(_ctx.$localize('drive.section.button.view_all')), 1)
          ]),
          main: _withCtx(() => [
            (_ctx.mainStore.isMobile)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["photo-wrapper", {'jc-start': _ctx.photos.length < 3}]),
                  ref: "scroller",
                  onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
                }, [
                  (!_ctx.dataLoading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoSkeletons, (n) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "photo",
                            key: n
                          }, [
                            _createVNode(_component_app_skeleton_media, { "hide-text": "" })
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: photo.id + photo.fileUrl,
                            class: "photo"
                          }, [
                            (photo.type === _ctx.MEDIA_TYPES.PHOTO)
                              ? (_openBlock(), _createBlock(_component_item_photo, {
                                  key: 0,
                                  photo: photo,
                                  onClick: ($event: any) => (_ctx.selectPhoto(photo)),
                                  hideDelete: "",
                                  blockGrid: "",
                                  "hide-title": ""
                                }, null, 8, ["photo", "onClick"]))
                              : _createCommentVNode("", true),
                            (photo.type === _ctx.MEDIA_TYPES.VIDEO)
                              ? (_openBlock(), _createBlock(_component_item_video, {
                                  key: 1,
                                  file: photo,
                                  thumbnail: "",
                                  "hide-title": ""
                                }, null, 8, ["file"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.dataLoading || _ctx.isPageLoading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(18, (n) => {
                        return _createElementVNode("div", {
                          class: "photo",
                          key: n
                        }, [
                          _createVNode(_component_app_skeleton_media, { "hide-text": "" })
                        ])
                      }), 64))
                    : _createCommentVNode("", true),
                  (_ctx.photos.length === 50)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "viewAll",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewAllPhotos && _ctx.viewAllPhotos(...args)))
                      }, [
                        _hoisted_2,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$localize('drive.section.button.view_all')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 34))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_swiper, {
                    class: "photo-wrapper d-slider",
                    "slides-per-view": 8,
                    "space-between": 12,
                    onReachEnd: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleScroll(true)))
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.dataLoading)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.photos, (photo) => {
                            return (_openBlock(), _createBlock(_component_swiper_slide, {
                              key: photo.id + photo.fileUrl,
                              class: "photo d-slider__slide"
                            }, {
                              default: _withCtx(() => [
                                (photo.type === _ctx.MEDIA_TYPES.PHOTO)
                                  ? (_openBlock(), _createBlock(_component_item_photo, {
                                      key: 0,
                                      photo: photo,
                                      onClick: ($event: any) => (_ctx.selectPhoto(photo)),
                                      hideDelete: "",
                                      blockGrid: "",
                                      "hide-title": ""
                                    }, null, 8, ["photo", "onClick"]))
                                  : _createCommentVNode("", true),
                                (photo.type === _ctx.MEDIA_TYPES.VIDEO)
                                  ? (_openBlock(), _createBlock(_component_item_video, {
                                      key: 1,
                                      file: photo,
                                      thumbnail: "",
                                      "hide-title": ""
                                    }, null, 8, ["file"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        : _createCommentVNode("", true),
                      (_ctx.dataLoading || _ctx.isPageLoading)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(18, (n) => {
                            return _createVNode(_component_swiper_slide, {
                              class: "photo d-slider__slide",
                              key: n
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_app_skeleton_media, { "hide-text": "" })
                              ]),
                              _: 2
                            }, 1024)
                          }), 64))
                        : _createCommentVNode("", true),
                      (_ctx.photos.length === 50)
                        ? (_openBlock(), _createBlock(_component_swiper_slide, {
                            key: 2,
                            class: "d-slider__slide"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", {
                                  class: "viewAll",
                                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.viewAllPhotos && _ctx.viewAllPhotos(...args)))
                                }, _hoisted_7)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}